import { storage } from '@/entities/map'

const DEFAULT_ZOOM_LEVEL = 13 // 1km

const DEFAULT_COORDINATES = {
  lat: 37.54999,
  lng: 126.98963,
}

export const getMapOptions = ({
  lat,
  lng,
  zoomLevel: zoomLevelProp,
}: {
  lat: string | null
  lng: string | null
  zoomLevel: string | null
}) => {
  const center = (() => {
    if (lat && lng) {
      return { lat: Number(lat), lng: Number(lng) }
    }

    return storage.getCoordinates() ?? DEFAULT_COORDINATES
  })()
  const zoomLevel = (() => {
    if (zoomLevelProp) {
      return Number(zoomLevelProp)
    }

    return storage.getZoomLevel() ?? DEFAULT_ZOOM_LEVEL
  })()

  return {
    zoom: zoomLevel,
    minZoom: 6,
    maxZoom: 19,
    center,
  }
}
